import { cn } from "@teamworksdev/react";
import type { HTMLAttributes } from "react";
import { getContrastTextColor, HEX_COLOR_REGEX, isWhite } from "~/utils/color";

type ColorSwatchProps = HTMLAttributes<HTMLDivElement> & {
  className?: string;
  color?: string | null;
};

export const ColorSwatch = ({ className, color, ...props }: ColorSwatchProps) => (
  <div
    className={cn(
      "w-full h-5 px-4 flex items-center justify-center bg-white border rounded-[3px] border-light-300 text-xs",
      {
        "border-white/50": !!color && !isWhite(color),
        "border-black/50": !color || isWhite(color),
      },
      className,
    )}
    style={{
      backgroundColor: color ?? "",
      color: color ? getContrastTextColor(color) : "",
    }}
    {...props}
  >
    {color ? color.toUpperCase() : <div className="bg-error-200 rounded-sm h-0.5 grow" />}
  </div>
);

type ColorSwatchRoundProps = ColorSwatchProps & {
  size?: number;
};

export const ColorSwatchRound = ({ className, color, size = 20, ...props }: ColorSwatchRoundProps) => {
  const isValidColor = !!color && HEX_COLOR_REGEX.test(color);

  if (!isValidColor)
    return (
      <div
        className="rounded-full bg-white border border-light-300 flex items-center justify-center"
        style={{ width: size, height: size }}
        {...props}
      >
        <div className="bg-error-200 rounded-sm h-0.5 -rotate-45" style={{ width: size * 0.75 }} />
      </div>
    );

  return (
    <div
      className={cn(
        "rounded-full border",
        {
          "border-white/50": !!color && !isWhite(color),
          "border-black/50": !color || isWhite(color),
        },
        className,
      )}
      style={{ width: size, height: size, backgroundColor: color }}
      {...props}
    />
  );
};
